import { render, staticRenderFns } from "./vizual_monitors.vue?vue&type=template&id=0d4b04c6&"
import script from "./vizual_monitors.vue?vue&type=script&lang=js&"
export * from "./vizual_monitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports